<div class="train-route-content clearfix  {{'Y'===trainData?.atOriginInd?'route-origin2-line':''}}">
	<div class="origin-loc pull-left" *ngIf="'Y'!==trainData?.atOriginInd">
		<span class="origin-station">
		<b>{{trainData?.originTerminal}}</b>
		{{originTerminalValue? originTerminalValue : '-'}}
		</span></div>
	<div class="current-loc pull-left {{isNextDestinationSame?'route2':''}} {{'Y'===trainData?.atOriginInd?'route-origin2':''}}">
		<span class="current-loc-tag">{{'Y'===trainData?.atOriginInd?'Origin (Current)':trainLabel.routeCurrent}}</span>
		<div class="current-station">
			<strong>{{trainData?.currentTerminal}}</strong> {{currentTerminalValue? currentTerminalValue : '-'}}
		</div>
		<ul class="location-data-style">
			<li *ngIf="trainTypeValue">{{trainTypeValue}}</li>
			<li>
				<label>{{trainLabel.trainSchedule}}:</label>
				<strong>{{trainData?.scheduledDateTime? trainData?.scheduledDateTime : '-'}}</strong>
			</li>
			<li>
				<label>{{currentCrewLabel}}</label>
				<strong>{{currentCrewTime}}</strong></li>
		</ul>
	</div>
	<!--*ngIf='trainData && trainData?.nextTerminal && trainData?.destinationTerminal && (trainData?.nextTerminal !== trainData?.destinationTerminal)'-->
	<div class="next-loc pull-left {{isNextDestinationSame && 'Y'!==trainData?.atOriginInd?'route3':''}} {{'Y'===trainData?.atOriginInd && !isNextDestinationSame ?'route-origin3':''}} {{isNextDestinationSame && 'Y'===trainData?.atOriginInd?'org-dest-only':''}}">
		<span class="next-loc-tag">{{isNextDestinationSame?'Destination (Next)':trainLabel.routeNext}}</span>
		<div class="next-station">
			<strong>{{trainData?.nextTerminal}}</strong> {{nextTerminalValue? nextTerminalValue : '-'}}
		</div>
		<ul class="location-data-style">
			<li><label>{{trainLabel.trainETA}}:</label> <strong>{{trainData?.etaDateTime? trainData?.etaDateTime : '-'}}</strong></li>
			<li><label>{{nextCrewLabel}}</label> <strong>{{nextCrewTime}}</strong></li>
		</ul>
	</div>
	<div class="des-loc pull-left {{'Y'===trainData?.atOriginInd?'route-origin4':''}}" *ngIf="!isNextDestinationSame">
		<div class="dest-station">
			<strong>{{trainData?.destinationTerminal}}</strong> {{destinationTerminalValue? destinationTerminalValue : '-'}}
		</div>
		<ul class="location-data-style">
			<li><label>{{trainLabel.trainETA}}:</label>
				<strong>{{trainData?.etaDestination? trainData?.etaDestination : '-'}}</strong></li>
		</ul>
	</div>
	<div class="clearfix"></div>
</div>